import { render, staticRenderFns } from "./sendmoney.vue?vue&type=template&id=74a735fc&"
import script from "./sendmoney.vue?vue&type=script&lang=js&"
export * from "./sendmoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports